export default {
  heroTitle: 'USFans Spreadsheet — The Complete Resource for Products, Sellers, QC & Shipping',
  heroSubtitle: 'Explore the latest USFans spreadsheet resources, product guides, seller information, QC tips, shipping insights and helpful buying resources — all organized in one easy-to-use hub.',
  heroTrust: 'Updated Resources • Practical Guides • Independent Information',
  readGuide: 'Read the Complete Guide',

  whatTitle: 'What Is the USFans Spreadsheet?',
  whatCopy: 'The USFans Spreadsheet is a convenient way to organize and explore useful product, seller and buying resources. Our independent resource hub helps you navigate spreadsheet-related information, product research, quality checks, shipping topics and other useful USFans guides without wasting time searching across multiple sources.',
  exploreSpreadsheet: 'Explore the Spreadsheet',

  resourcesTitle: 'Explore USFans Spreadsheet Resources',
  resourcesSubtitle: 'Structured guides for every step of your research, from discovery to delivery.',
  resource1Title: 'USFans Spreadsheet',
  resource1Desc: 'Find organized spreadsheet resources and useful product information.',
  resource2Title: 'USFans Sellers',
  resource2Desc: 'Explore seller-related resources and learn how to evaluate listings.',
  resource3Title: 'USFans QC Guide',
  resource3Desc: 'Learn what to check before making a purchase.',
  resource4Title: 'USFans Shipping',
  resource4Desc: 'Understand shipping methods, costs, delivery considerations and common questions.',
  resource5Title: 'USFans Warehouse',
  resource5Desc: 'Learn how warehouse storage, inspection and product handling work.',
  resource6Title: 'USFans Review',
  resource6Desc: 'Explore an independent overview of USFans features, usability and common questions.',

  whyTitle: 'Everything You Need to Research USFans in One Place',
  whyCopy: 'Searching for USFans information can be time-consuming when useful resources are scattered across different pages. USFansLink brings related guides, spreadsheet resources, seller information, QC tips, shipping information and safety guidance into one structured resource hub.',
  benefit1: 'Organized USFans Spreadsheet resources',
  benefit2: 'Easy-to-follow buying guides',
  benefit3: 'Shipping and warehouse information',
  benefit4: 'QC and product research guides',
  benefit5: 'Updated educational content',
  benefit6: 'Independent safety information',

  featuredTitle: 'Start With the USFans Spreadsheet Guide',
  featuredCopy: 'New to USFans? Start with our complete spreadsheet guide. Learn how to navigate spreadsheet resources, research products, understand seller information, review QC details and find the information you need before moving forward.',

  reviewTitle: 'USFans Review: What You Should Know',
  reviewCopy: 'Looking for an unbiased overview? Our USFans review covers the key topics users commonly research, including usability, product discovery, warehouse processes, shipping, costs, safety considerations and frequently asked questions.',
  readReview: 'Read USFans Review',

  safetyTitle: 'Stay Safe While Researching USFans Resources',
  safetyCopy: 'Protect your account and personal information. Never share passwords, verification codes or payment credentials through unverified channels. Always check links carefully and use secure websites before submitting sensitive information.',
  readSafety: 'Read the USFans Safety Guide',

  articlesTitle: 'Latest USFans Spreadsheet Articles',
  articlesSubtitle: 'Original, in-depth guides written to help you research with confidence.',
  article1Title: 'USFans Spreadsheet: Complete Guide, Links & Resources 2026',
  article1Desc: 'Everything you need to know about navigating spreadsheet resources, product research, QC, shipping and more.',
  articleReadMore: 'Read Article',

  finalTitle: 'Ready to Explore USFans Spreadsheet Resources?',
  finalCopy: 'Find useful guides, spreadsheet resources, seller information, QC tips and shipping insights in one organized hub.',
};